<template>
  <div id="app">
    <nav-infoq></nav-infoq>
    <!-- <we-code></we-code> -->
    <gi-nav :menu="data['导航栏']" :logo="data['导航栏'].logo"></gi-nav>

    <!-- banner -->
    <a
      :href="data.banner.link"
      target="_blank"
      class="banner is-tablet"
      :style="`background-image: url('${data.banner['图片（pc）']}')`"
    ></a>
    <a :href="data.banner.link" class="mobile-banner mobile-show">
      <img :src="data.banner['图片（mobile）']" alt />
    </a>
    <!-- banner -->

    <!-- 头条新闻 -->
    <div class="b-toutiao c-box" id="toutiao" v-if="data['头条新闻']['是否显示']">
      <gi-title :data="data['头条新闻'].title" theme="light"></gi-title>
      <div class="container">
        <div class="columns is-gapless">
          <div class="column is-left is-narrow">
            <el-carousel id="carousel" class="swiper1" :interval=4000 height="150px" @change="moveMove">
              <el-carousel-item
                v-if="item"
                v-for="(item, index) in data['头条新闻']['left']['imgList']"
                :key="item + '' + index"
              >
                <img :src="item" alt width="100%" height="100%" :data-id="index" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="column is-right">
            <div class="right">
              <h1>{{data['头条新闻']['right']['list'][imgIndex]['标题']}}</h1>
              <p>{{data['头条新闻']['right']['list'][imgIndex]['介绍']}}</p>
              <div class="link">
                <a
                  target="_blank"
                  :href="data['头条新闻']['right']['list'][imgIndex]['link']"
                >{{data['头条新闻']['right']['more']}}</a>
                <!-- <span v-else @click="openLive(data['头条新闻']['right'])">{{data['头条新闻']['right']['liveTip']}}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 头条新闻 -->

    <!-- 大会报到 -->
    <gi-box class="b-case" id="xiaoxi" v-if="data['大会报到']['是否显示']">
      <div class="container">
        <gi-title :data="data['大会报到'].title"></gi-title>
        <div class="columns is-multiline">
          <div v-for="(item, index) in news" v-if="item['图片']" class="column is-one-third-tablet">
            <gi-card :data="item" :type="'news'" :i="index"></gi-card>
          </div>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 30px">
          <div class="loadmore">
            <a @click="moreNews" class="button is-loadmore" v-if="news.length < len(newsAll)">加载更多>></a>
          </div>
        </div>
      </div>
    </gi-box>
    <!-- 大会报到 -->

    <!--相关资讯-->
    <div class="b-essays c-box" id="essays" v-if="data['相关资讯']['是否显示']">
      <gi-title :data="data['相关资讯'].title"></gi-title>
      <div class="container">
        <div class="columns is-multiline is-3 is-variable">
          <div v-for="item in essays" v-if="item['图片']" class="column is-half-tablet essay">
            <gi-card3 :data="item"></gi-card3>
          </div>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 30px">
          <div class="loadmore">
            <a
              @click="moreEssays"
              class="button is-loadmore"
              v-if="essays.length < len(essaysAll)"
            >加载更多>></a>
          </div>
        </div>
      </div>
    </div>
    <!--相关资讯-->

    <!-- 精彩瞬间 -->
    <div class="b-image c-box" id="image" v-if="data['精彩瞬间']['是否显示']">
      <div class="container">
        <gi-title :data="data['精彩瞬间'].title"></gi-title>
        <el-carousel
          class="swiper2"
          v-if="screenWidth > 768"
          :interval="3000"
          type="card"
          arrow="always"
          :autoplay="false"
          :loop="true"
          :initial-index="1"
        >
          <template v-for="(img, index) in data['精彩瞬间']['图片链接']">
            <el-carousel-item v-if="img" :key="index">
              <img :src="img" alt />
            </el-carousel-item>
          </template>
        </el-carousel>
        <div v-else>
          <swiper :options="swiperOption">
            <swiper-slide v-for="(img, index) in data['精彩瞬间']['图片链接']" :key="index" v-if="img">
              <img :src="img" alt />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="link">
          <a :href="data['精彩瞬间']['link']" v-if="data['精彩瞬间']['more']">{{data['精彩瞬间']['more']}}</a>
        </div>
      </div>
    </div>
    <!-- 精彩瞬间 -->

    <!-- 视频直击 -->
    <div class="b-video c-box" id="video" v-if="data['视频回放']['是否显示']">
      <div class="container">
        <gi-title :data="data['视频回放'].title"></gi-title>
        <div class="columns is-multiline">
          <div v-for="video in videos" v-if="video['图片']" class="column is-one-third-tablet">
            <gi-card2 :data="video"></gi-card2>
          </div>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 30px">
          <div class="loadmore">
            <a
              @click="moreVideo"
              class="button is-loadmore"
              v-if="videos.length < len(videosAll)"
            >加载更多>></a>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频直击 -->

    <!-- 加入群组 -->
    <div id="join" v-if="data['加入群组']['是否显示']">
  <join-info :infoData="data['加入群组']">
  </join-info>
    </div>
    <div class="footer1">
      <p>Copyright © 2019, Geekbang Technology Ltd. All rights reserved. 极客邦控股（北京）有限公司 | 京 ICP 备 16027448 号 - 5</p>
    </div>

    <edit :data="data" :debug="false"></edit>
  </div>
</template>

<script>
import axios from "axios";
import data from "./data";
import NavInfoq from "./components/navinfoq";
import GiNav from "./components/nav";
import GiTitle from "./components/title";
import Live from "./components/live";
import GiBox from "./components/box";
import GiCard from "./components/card";
import GiCard2 from "./components/card2";
import GiCard3 from "./components/card3";
import comBtn from "./components/com-button";
import JoinInfo from "./components/joinInfo";
import Edit from "common/components/edit";
import temp from "./temp";

export default {
  components: {
    Edit,
    NavInfoq,
    GiNav,
    GiTitle,
    GiBox,
    GiCard,
    GiCard2,
    GiCard3,
    comBtn,
    Live,
    JoinInfo
  },
  data() {
    var d = window.GEEKBANG_DATA || data;
    return {
      screenWidth: document.body.clientWidth,
      status: "prod", // prod, editing
      data: d,
      liveData: {},
      isLive: false,
      newsAll: d["大会报到"].list,
      news: d["大会报到"].list.slice(0, 6),
      essaysAll: d["相关资讯"].list,
      essays: d["相关资讯"].list.slice(0, 6),
      videosAll: d["视频回放"].list,
      videos: d["视频回放"].list.slice(0, 6),
      videoLink: "",
      swiperOption: {
        pagination: '.swiper-pagination',
        paginationClickable: true
      },
      imgIndex: 0
    };
  },
  watch: {
    screenWidth() {
      this.refresh();
    }
  },
  computed: {
    // news() {
    //   return this.data["大会报到"].list.slice(this.data["大会报到"].list.length - 6)
    // }
  },
  methods: {
    moveMove(index) {
      this.imgIndex = index;
    },
    moreVideo() {
      this.videos = this.data["视频回放"].list;
    },
    openVideos(data) {
      this.videoLink = data.link;
      window.location.href = this.videoLink;
      // this.$refs['video'].playVideo()
    },
    refresh() {
      // 根据屏幕宽度控制历史活动显示数量
      var d = window.GEEKBANG_DATA || data;
    },
    len(arr) {
      return arr.filter(d => d["图片"]).length;
    },
    moreEssays() {
      this.essays = this.essaysAll;
    },
    moreNews() {
      this.news = this.newsAll;
    },
    moreVideo() {
      this.videos = this.data["视频回放"].list;
    },
    initWxConfig() {
      let data = this.data["微信分享"];
      const ua = window.navigator.userAgent;
      if (!ua.match(/MicroMessenger/i)) return;
      let url = window.location.href;
      axios
        .get(
          `https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(
            url
          )}&mpid=gh_a4dbefba05a2`
        )
        .then(res => {
          if (res.data.code === 0) {
            if (!window.wx) return;
            window.wx.config({
              debug: false,
              appId: res.data.data.appId,
              timestamp: res.data.data.timestamp,
              nonceStr: res.data.data.nonceStr,
              signature: res.data.data.signature,
              jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
            });
          }
        })
        .catch(res => {});
      window.wx.ready(function() {
        window.wx.onMenuShareTimeline({
          title: data["标题"],
          imgUrl: data["图片"],
          link: window.location.href,
          success: function() {},
          cancel: function() {}
        });
        window.wx.onMenuShareAppMessage({
          title: data["标题"],
          desc: data["介绍"],
          imgUrl: data["图片"],
          link: window.location.href,
          type: "link",
          dataUrl: "",
          success: () => {},
          cancel: () => {}
        });
      });
    }
  },
  created() {

    // this.data['头条新闻']['left']['imgList'].reverse();
    // this.data['头条新闻']['right']['list'].reverse();
    // this.data['大会报到']['list'].reverse();
    // this.data['相关资讯']['list'].reverse();
    // this.data['精彩瞬间']['图片链接'].reverse();
    // this.data['视频回放']['list'].reverse();

    // axios.get('https://static-data.geekbang.org/aws2017/data.json')
    // .then(res => {
    //   this.newsbac = res.data.articles.map(a => {
    //     var arr = a.description.split('#time#')
    //     a.description = arr[0]
    //     a.tip = arr[1]
    //     return a
    //   })
    //   this.news = res.data.articles.slice(0, 6)
    // })
 
    this.refresh();
    this.initWxConfig();
    if (
      window.location.protocol.indexOf("file") > -1 ||
      window.location.search.indexOf("status=editing") > -1
    ) {
      this.status = "editing";
    }
    window.onmousemove = e => {
      if (this.dashboard.draging) {
        this.dashboard.left = e.clientX - this.dashboard.dragstartx + "px";
        this.dashboard.top = e.clientY - this.dashboard.dragstarty + "px";
      }
    };
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  }
};
</script>

<style lang="sass">
  =mobile
    @media screen and (max-width: 768px)
      @content

  =tablet
    @media screen and (min-width: 769px)
      @content

  @import "./style/variable"
  .link
    margin-top: 40px
  .is-right p
    word-break: break-all
  .essay:hover
    box-shadow: 1px 1px 5px #ccc
  #carousel
    width: 100%
    height: 100%
    overflow: hidden
    .el-carousel__container
    height: 366px !important
  .el-carousel__item
    img
      height: 100%
      border-radius: 4px
  .el-carousel__mask
    opacity: .5
  .el-carousel__arrow
    display: flex
    width: 45px
    height: 45px
    align-item: center
    justify-content: center
    background-color: rgba(31,45,61,.2)
    +mobile
      display: none
  .el-carousel__arrow:hover
    background-color: rgba(31,45,61,.8)
  .el-carousel__arrow--left
    i:before
      content: ''
      display: block
      width: 12px
      height: 21px
      background: url(./assets/arrow.png) left top/cover
      transform: rotate(180deg) translateX(2px)
  .el-carousel__arrow--right
    i:before
      content: ''
      display: block
      width: 12px
      height: 21px
      background: url(./assets/arrow.png) left top/cover
      transform: translateX(1px)
  .mobile-banner
    display: block
    width: 100%
    margin-bottom: 20px
  .footer1
    width: 100%
    background: #e8e8e8
    color: #888
    height: 60px
    text-align: center
    line-height: 60px
    font-size: 14px
    +mobile
      line-height: 1.2em
      display: flex
      align-items: center
  .img-wrapper
    display: flex
    align-items: center
  .el-carousel__container
    height: 388px !important
  .el-carousel__item
    img
      height: 100%
      border-radius: 4px
  .el-carousel__mask
    opacity: .5
  .el-carousel__arrow
    display: flex
    width: 45px
    height: 45px
    align-item: center
    justify-content: center
    background-color: rgba(31,45,61,.2)
    +mobile
      display: none
  .el-carousel__arrow:hover
    background-color: rgba(31,45,61,.8)
  .el-carousel__arrow--left
    i:before
      content: ''
      display: block
      width: 12px
      height: 21px
      background: url(./assets/arrow.png) left top/cover
      transform: rotate(180deg) translateX(2px)
  .el-carousel__arrow--right
    i:before
      content: ''
      display: block
      width: 12px
      height: 21px
      background: url(./assets/arrow.png) left top/cover
      transform: translateX(1px)
  .swiper2 .el-carousel__indicators
    display: none
  .swiper2 .el-carousel__item.is-active
    width: 120%
  .swiper-pagination-bullet
    background: #fff
    

    
</style>
